"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/input-number/style/css");

var _inputNumber = _interopRequireDefault(require("antd/es/input-number"));

require("antd/es/checkbox/style/css");

var _checkbox = _interopRequireDefault(require("antd/es/checkbox"));

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/form/style/css");

var _form = _interopRequireDefault(require("antd/es/form"));

var _react = _interopRequireDefault(require("react"));

require("../activity.scss");

var _OptionFeedbackItem = _interopRequireDefault(require("../feedback/OptionFeedbackItem"));

var _ActivityFormContainer = require("../ActivityFormContainer");

const {
  Item
} = _form.default;

const QuizOption = props => {
  const {
    option,
    disabled,
    onTextChange,
    onPointsChange,
    onCorrectChange,
    updateFeedback,
    removeFeedback,
    addFeedback
  } = props;
  const {
    text,
    points,
    isCorrect,
    feedback,
    id,
    uuid
  } = option;
  return /*#__PURE__*/_react.default.createElement(Item, {
    key: `quiz-option-${id || uuid}`,
    name: `quiz-option-${id || uuid}`,
    className: "option-container"
  }, /*#__PURE__*/_react.default.createElement(Item, {
    key: `quiz-option-text-${id || uuid}`,
    name: `quiz-option-text-${id || uuid}`,
    rules: [{
      required: true,
      message: 'Option must have text.'
    }],
    initialValue: text
  }, /*#__PURE__*/_react.default.createElement(_input.default, {
    spellCheck: true,
    disabled: disabled,
    placeholder: "Option text",
    onChange: onTextChange,
    style: {
      width: '100%'
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "option-props"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "option-prop"
  }, "Correct Answer", ' ', /*#__PURE__*/_react.default.createElement(_checkbox.default, {
    disabled: disabled,
    checked: isCorrect,
    onChange: onCorrectChange
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "option-prop"
  }, "Point Value", ' ', /*#__PURE__*/_react.default.createElement(_inputNumber.default, {
    disabled: disabled,
    value: points,
    min: 0,
    onChange: onPointsChange
  }))), /*#__PURE__*/_react.default.createElement("h4", null, "Option Feedback:"), /*#__PURE__*/_react.default.createElement(_OptionFeedbackItem.default, {
    type: _ActivityFormContainer.Type.quiz,
    disabled: disabled,
    feedback: feedback,
    option: option,
    updateFeedback: updateFeedback,
    addFeedback: addFeedback,
    removeFeedback: removeFeedback
  }));
};

var _default = QuizOption;
exports.default = _default;